$traceurRuntime.ModuleStore.getAnonymousModule(function() {
  "use strict";
  angular.module('app.module').service('ChannelAPI', (function() {
    var api = null;
    return {
      set: (function(channel) {
        api = {
          pushMessageScreen: (function(subtype, title, message, icon) {
            if (!channel)
              return;
            channel.push('show_screen', {
              type: 'message',
              subtype: (subtype ? 'results' : false),
              feedback: (subtype ? subtype : false),
              message: message,
              title: title,
              icon: icon
            });
          }),
          pushQuestion: (function(type, subtype, title, answers, countdown, scope, callback) {
            if (!channel)
              return;
            channel.push('show_screen', {
              type: type,
              title: title,
              answers: answers,
              subtype: (subtype ? subtype : false),
              feedback: scope.slide.feedback,
              id: scope.slideID
            });
            channel.push('question_start', {countdown: countdown});
            channel.on(scope, 'question_start', (function(r) {
              callback('start', r);
            }));
            channel.on(scope, 'question_countdown', (function(r) {
              callback('countdown', r);
            }));
            channel.on(scope, 'question_stop', (function(r) {
              callback('stop', r);
            }));
          }),
          cancelQuestion: (function() {
            return channel.push('question_cancel', {});
          })
        };
        return api;
      }),
      get: (function() {
        if (!api)
          throw ("ChannelAPI get() before set()");
        return api;
      })
    };
  })).service('AnswerAPI', function($http, $rootScope, AudioManager) {
    var stage = 'initial',
        selected = [],
        score = [],
        multiple = false,
        checkCount = 0,
        countdownRemaining = false;
    return {
      reset: (function() {
        selected = [];
      }),
      select: (function(index, multiple) {
        AudioManager.play('click');
        if (selected.indexOf(index) < 0) {
          if (!multiple) {
            selected = [];
          }
          selected.push(index);
        } else if (selected.indexOf(index) > -1) {
          var selection_index = parseInt(selected.indexOf(index));
          selected.splice(selection_index, 1);
        }
        return selected;
      }),
      check: (function(correct, selected) {
        checkCount++;
        var correctSelected = _.filter(selected, function(o) {
          return correct.indexOf(o) >= 0;
        });
        var wrongSelected = _.filter(selected, function(o) {
          return correct.indexOf(o) < 0;
        });
        var feedback = {};
        if (!selected.length) {
          feedback['type'] = 'error';
          feedback['title'] = "Jullie moeten natuurlijk wel eerst een antwoord kiezen";
          AudioManager.play('error');
        } else if (correctSelected.length === correct.length && !wrongSelected.length) {
          feedback['type'] = 'correct';
          feedback['title'] = "Goed gedaan!";
          AudioManager.play('correct');
        } else {
          if (checkCount >= 3) {
            feedback['type'] = 'too-many-tries';
            feedback['title'] = "Goed geprobeerd, maar helaas...";
            AudioManager.play('error');
          } else {
            if (correctSelected.length === correct.length) {
              feedback['type'] = 'missing';
              feedback['title'] = "Goed op weg, maar jullie zijn er nog niet!";
              feedback['count_correct'] = correct.length;
              feedback['count_selected'] = selected.length;
              AudioManager.play('error');
            } else {
              feedback['type'] = 'wrong';
              feedback['title'] = "Helaas...";
              AudioManager.play('error');
            }
          }
        }
        return feedback;
      }),
      vote: (function(multiple, subtype, title, answers, countdown, scope) {
        var type = (!multiple ? 'question' : 'toggles');
        console.log(subtype);
        scope.api.pushQuestion(type, subtype, title, answers, countdown, scope, (function(event, data) {
          switch (event) {
            case 'start':
              scope.slideObj.stage = 'countdown';
              scope.isCounting = true;
              break;
            case 'countdown':
              scope.countdownRemaining = data.countdown;
              scope.countdownPercentage = (scope.countdownRemaining / countdown * 100) + '%';
              break;
            case 'stop':
              scope.isCounting = false;
              scope.slideObj.stage = 'counted';
              var percentages = {};
              var scores = {};
              var winner = -1;
              var mx = 0;
              if (!multiple) {
                for (var k in data.scores) {
                  percentages[k] = data.scores[k] / data.answer_count;
                  if (percentages[k] >= mx) {
                    winner = parseInt(k, 10);
                    mx = percentages[k];
                  }
                }
              } else {
                var total_users = Object.keys(data.scores).length;
                for (var u in data.scores) {
                  for (var a in data.scores[u]) {
                    if (data.scores[u][a]) {
                      scores[a] = (scores[a] || 0) + 1;
                    } else {
                      scores[a] = (scores[a] || 0) + 0;
                    }
                  }
                }
                percentages = JSON.parse(JSON.stringify(scores));
                for (var a in percentages) {
                  percentages[a] /= total_users;
                }
                console.log(percentages);
              }
              scope.api.pushMessageScreen(false, scope.chapterPagination, "De uitslag is bekend.", "thumb-up");
              scope.$emit('voteDone', {
                scores_per_answer: (multiple ? scores : data.scores),
                scores: data.scores,
                percentages: percentages,
                winner: winner,
                max: mx
              });
              break;
          }
          scope.countdownRemaining = data.countdown;
        }));
      }),
      checkVote: (function(multiple, correct_answers, data) {
        var total = 0;
        var correct = 0;
        var percentage = 0;
        if (multiple) {
          for (var userId in data.scores) {
            var answers = data.scores[userId];
            var selected = [];
            for (var answerId in answers) {
              if (answers[answerId]) {
                selected.push(parseInt(answerId, 10));
              }
            }
            selected.sort();
            total += 1;
            if (_.isEqual(selected, correct_answers)) {
              correct += 1;
            }
          }
          if (total > 0) {
            percentage = parseFloat(correct / total).toFixed(2) * 100;
          }
        } else {
          percentage = parseFloat(data.percentages[correct_answers]).toFixed(2) * 100 || 0;
        }
        var feedback = {};
        console.log(percentage);
        if (percentage == 100) {
          feedback['type'] = 'correct';
          feedback['title'] = "Wow! Iedereen had het goed!";
          AudioManager.play('correct');
        } else if (percentage < 1) {
          feedback['type'] = 'wrong';
          feedback['title'] = "Balen zeg... Niemand had het goed!";
          AudioManager.play('error');
        } else if (percentage >= 50) {
          feedback['type'] = 'correct-50';
          feedback['title'] = percentage + "% had het goed!";
          AudioManager.play('correct');
        } else {
          feedback['type'] = 'wrong-50';
          feedback['title'] = "Slechts " + percentage + "% had het goed!";
          AudioManager.play('error');
        }
        feedback['percentage'] = percentage;
        return feedback;
      }),
      checkDragDrop: (function(subtype, correct, selected) {
        checkCount++;
        var feedback = {};
        var correct_answer = false;
        var correct_answer_array = [];
        var correct_answer_feedback = [];
        var correct_answer_feedback = JSON.parse(JSON.stringify(selected));
        for (var z = 0,
            len = selected.length; z < len; z++) {
          correct_answer_feedback[z].items = [];
        }
        for (var z = 0,
            len = selected.length; z < len; z++) {
          for (var i = 0,
              count = selected[z].items.length; i < count; i++) {
            var label = selected[z].items[i].label;
            var indexCorrect = _.findLastIndex(correct, {label: label});
            if (subtype == 'word-connect') {
              var indexCorrect = _.findLastIndex(correct, {connection: label});
            }
            if (indexCorrect >= 0) {
              if (subtype == 'sort') {
                var correct_answer = (parseInt(correct[indexCorrect].order) === (i + 1) ? true : false);
                selected[z].items[i].correct = correct_answer;
                correct_answer_feedback[z].items[parseInt(correct[indexCorrect].order - 1)] = selected[z].items[i];
              }
              if (subtype == 'drag-drop') {
                var correct_answer = (parseInt(correct[indexCorrect].zone) === (z + 1) ? true : false);
                selected[z].items[i].correct = correct_answer;
                correct_answer_feedback[parseInt(correct[indexCorrect].zone - 1)].items.push(selected[z].items[i]);
              }
              if (subtype == 'word-connect') {
                var correct_answer = (indexCorrect === z ? true : false);
                selected[z].items[i].correct = correct_answer;
                correct_answer_feedback[indexCorrect].items.push(selected[z].items[i]);
              }
              if (subtype == 'image-connect') {
                var correct_answer = (indexCorrect === z ? true : false);
                selected[z].items[i].correct = correct_answer;
                correct_answer_feedback[indexCorrect].items.push(selected[z].items[i]);
              }
              correct_answer_array.push(correct_answer);
            }
          }
        }
        var answer_count = _.countBy(correct_answer_array, function(correct) {
          return (correct ? 'correct' : 'wrong');
        });
        console.log(answer_count);
        if (!_.contains(correct_answer_array, false)) {
          feedback['type'] = 'correct';
          feedback['title'] = "Helemaal goed!";
          feedback['subtitle'] = "Alle " + correct_answer_array.length + " goed!";
          feedback['correct'] = correct_answer_feedback;
          AudioManager.play('correct');
        } else {
          if (checkCount >= 3) {
            feedback['type'] = 'too-many-tries';
            feedback['title'] = "Goed geprobeerd, maar helaas...";
            feedback['subtitle'] = (typeof answer_count.correct != 'undefined' ? answer_count.correct : '0') + " van de " + correct_answer_array.length + " goed!";
            feedback['correct'] = correct_answer_feedback;
            checkCount = 0;
            AudioManager.play('error');
          } else {
            feedback['type'] = 'wrong';
            feedback['title'] = (typeof answer_count.correct != 'undefined' ? answer_count.correct : '0') + " van de " + correct_answer_array.length + " goed!";
            feedback['subtitle'] = "Probeer het nog eens";
            AudioManager.play('error');
          }
        }
        return feedback;
      })
    };
  });
  ;
  return {};
});

